import { nativeApplicationVersion } from "expo-application";
import { ReactNode } from "react";
import { Platform } from "react-native";

import { useFlags } from "../launchDarkly";
import { AppUpdateFullScreenBanner } from "./AppUpdateFullScreenBanner";

/**
 * This component handles checking the raw native app shell version.
 * It checks against the oldest supported version for the platform.
 * If the native app shell version is older than the oldest supported version,
 * we show a full screen banner to the user to update the app.
 */
export const NativeAppVersionCheckProvider = ({
  children,
}: {
  children: ReactNode | null;
}) => {
  const { nativeAppOldestSupportedVersions } = useFlags();
  if (Platform.OS !== "web") {
    const nativeAppVersionInt = nativeApplicationVersion
      ? parseInt(nativeApplicationVersion)
      : null;

    const oldestSupportedVersion =
      Platform.OS === "ios"
        ? nativeAppOldestSupportedVersions?.ios ?? null
        : nativeAppOldestSupportedVersions?.android ?? null;

    if (
      oldestSupportedVersion &&
      nativeAppVersionInt &&
      oldestSupportedVersion > nativeAppVersionInt
    ) {
      //We need to update the app
      return (
        <AppUpdateFullScreenBanner
          updateUrl={
            Platform.OS === "ios" ? iosAppStoreLink : googlePlayStoreLink
          }
        />
      );
    }
  }
  return <>{children}</>;
};

const iosAppStoreLink =
  "https://apps.apple.com/us/app/whoosh-member-app/id1610151814";

const googlePlayStoreLink =
  "https://play.google.com/store/apps/details?id=com.whoosh.whooshpatronapp&hl=en_US&gl=US";
